define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class EditionService
     */
    function EditionService($root, $q, $log, editionProvider, $indexedDB, $filter, commonService, localStorageService) {
        let self = this;

        self.url = editionProvider.getBdcUrl();
        /**
         * Create or update a client
         * @param  {int} id
         * @param {string} template
         * @return {Promise}
         */
        self.getPdfFromTemplate = function(id, template) {
            return editionProvider.getPdf(id, template).then(stream => {
                return self.getFileUrl(stream);
            });
        };

        self.getFileUrl = function(data) {
            return new Promise(function(resolve, reject) {
                let file = new Blob([data], { type: 'application/pdf' });
                // let file = new File([data], 'document.pdf', {'type': 'application/pdf'});
                // console.log(file);
                resolve(URL.createObjectURL(file));
            });
        };

        self.getAllPartners = function(env) {
            return editionProvider.getAllPartners(env).then(res => {
                return res;
            });
        };

        self.getDocumentsByPartner = function(id) {
            return editionProvider.getDocumentsByPartner(id).then(res => {
                return res;
            });
        };

        self.mergeDocumentWithCgv = function(b64) {
            return editionProvider.mergeDocumentWithCgv(b64).then(res => {
                return res;
            });
        }

        self.printBusiness = function(data) {
            return editionProvider.printBusiness(data).then(res => {
                return res;
            });
        }

        return self;
    }

    EditionService.$inject = [
        '$rootScope',
        '$q',
        '$log',
        'edition',
        '$indexedDB',
        '$filter',
        'commonService',
        'localStorageService'
    ];

    angular.module('app.kya.edition.editionService', []).factory('editionService', EditionService);
});
